import { useQuery } from '@tanstack/react-query';
import getRulesetDetail from 'Api/schedule-ruleset/getRulesetDetail';
import getRulesetDetailResponse from './model/response/getRulesetDetailResponse';

const useGetRulesetDetail = ({ id, enabled }) => {
  return useQuery({
    queryKey: ['ruleset-detail', id],
    queryFn: async () => {
      const response = await getRulesetDetail(id);

      const result = getRulesetDetailResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetRulesetDetail;
